import { createTheme } from "@mui/material/styles";


var theme = createTheme({
  	palette: {
		primary: {
			main: '#3182BD',
			weakpos: '#bdc9e1',
			negative: '#ff726f'
		},
		secondary: {
			main: '#f5f5f5',
		},
		background: {
			default: '#e5e5e5',
			paper: '#f5f5f5',
			secondary: '#f5f5f5'
		  },
		text: {
			primary: '#000000',
			secondary: '#7c7c7c',
		},
	},
})

theme = createTheme(theme, {
	components: {
		MuiTab: {
			styleOverrides: {
				root: {
					borderRadius: 5,

					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.secondary.main,
					}
				},
			}
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					borderBottom: "solid 1px",
					borderLeft: "solid 1px",
					padding: 2,
					paddingLeft: 8
				}
			}
		},
		MuiTable: {
			styleOverrides: {
				root: {
					borderRight: "solid 1px",
					borderTop: "solid 1px"
				}
			}
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					borderRadius: 5,
					'&.Mui-expanded': {
						backgroundColor: theme.palette.secondary.main,
						fontStyle: 'italic',
					}
				}
			}
		},

	},

	typography: {
		h3: {
			color: theme.palette.text.secondary,
		},
		h4: {
			color: theme.palette.text.secondary,
		},
	},
	
})


// theme = responsiveFontSizes(theme, {breakpoints: ['md', 'lg', 'xl']});

export default theme
